import Theme, { muiTheme } from 'styles/theme';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components/macro';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { useLoginPageState } from 'hooks/useLoginPageState';
import { SystemSettingsProvider } from 'components/providers/SystemSettingsProvider';
import { AuthenticatedUserProvider } from 'components/providers/AuthenticatedUserProvider';
import { ApplicationsFormsSchemasProvider } from 'components/providers/ApplicationsFormsSchemasProvider';

import { StyledToast } from './App.styles';
import { GlobalStyles } from 'styles/GlobalStyles';
import { ExternalLinkStateFields } from 'common/enum/external-link-state-fields';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const AppProviders = ({ children }) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get(ExternalLinkStateFields.TOKEN);

  const {
    selectedState: { isRootLogin, tenantName },
  } = useLoginPageState();

  return (
    <QueryClientProvider client={queryClient}>
      <ApplicationsFormsSchemasProvider
        token={token}
        tenantName={tenantName}
        isRootLogin={isRootLogin}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider theme={Theme}>
              <AuthenticatedUserProvider>
                <SystemSettingsProvider
                  token={token}
                  tenantName={tenantName}
                  isRootLogin={isRootLogin}
                >
                  <GlobalStyles />
                  {children}
                  <StyledToast autoClose={3000} hideProgressBar />
                </SystemSettingsProvider>
              </AuthenticatedUserProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </LocalizationProvider>
      </ApplicationsFormsSchemasProvider>
    </QueryClientProvider>
  );
};
